// Ireland import notifications that don't require action but are still worth surfacing to the user.
// Neither type sets declaration.actionRequired, so they're detected here instead.

import { IrelandNotification, IrelandNotificationType } from 'store/declarations/ireland/ireland-notification';

// Both are only relevant while they are the current/latest notification.
export const getIrelandNotificationMessage = (
    latestNotification: unknown
): { notification: IrelandNotification; messageName: string } | undefined => {
    const latest = latestNotification as IrelandNotification | undefined;

    // IM099 - DAFM general notification.
    if (latest?.type === IrelandNotificationType.GENERAL_NOTIFICATION && latest?.remarks?.includes('DAFM')) {
        return { notification: latest, messageName: 'IM099' };
    }

    // IM460 - Under control, with a control agency specified.
    const hasControlAgency = latest?.underControlGoodsShipmentItems?.some((item) => !!item.controlTypes?.length);
    if (latest?.type === IrelandNotificationType.UNDER_CONTROL && hasControlAgency) {
        return { notification: latest, messageName: 'IM460' };
    }

    return undefined;
};

export const getIrelandNotificationTooltip = (
    irelandMessage: ReturnType<typeof getIrelandNotificationMessage>
): string | undefined => {
    if (!irelandMessage) return undefined;

    const { notification, messageName } = irelandMessage;

    switch (messageName) {
        case 'IM099':
            return 'IM099 - DFMA Control';
        case 'IM460':
            return 'IM460 - Under Control';
        default:
            return notification.message;
    }
};
